import { clearZendeskChatOnLogout } from './zendesk-chat-session';

export const canUseDOM = () => Boolean(typeof window !== 'undefined'
  && window.document
  && window.document.createElement);

const isChatAvailable = () => Boolean(canUseDOM() && window.zE);

export const handleUpdateLocale = (locale: string) => {
  if (isChatAvailable()) {
    window.zE('messenger:set', 'locale', locale);
  }
};

export const handleUpdateUser = (name: string, email: string) => {
  if (isChatAvailable() && name && email) {
    // TODO :: implement zendesk jwt login
  }
};

// Function to handle opening and closing of Zendesk chat
export const handleStatus = (status: 'open' | 'close') => {
  if (isChatAvailable()) {
    // Call Zendesk API to open or close the chatWidget
    window.zE('messenger', status);
  }
};

export const logoutChatWidget = (): Promise<void> => clearZendeskChatOnLogout();
